import React from 'react'

const EditPage = () => {
  return (
    <div>EditPage</div>
  )
}

export default EditPage